import { leagueMeta, leagueOrder, matches, statusMeta, type LeagueKey, type Match, type MatchStatus } from '../mocks/matches';

export { leagueMeta, leagueOrder, matches, statusMeta };
export type { LeagueKey, Match, MatchStatus };

export const siteInfo = {
  name: '篮球直播',
  englishName: 'BBALL LIVE',
  slogan: '不看比分，看比赛',
  email: 'contact@basketballlive.cn',
  title: '篮球直播 - 实时篮球赛事在线直播平台',
  description:
    '篮球直播为您提供最新、最全的篮球赛事直播服务，涵盖NBA、CBA及国际篮球比赛，随时随地观看精彩赛事，不错过每一个精彩瞬间。',
  keywords: '篮球直播,篮球赛事,篮球比赛直播,NBA直播,CBA直播,篮球视频,篮球比赛',
};

export const matchTime = (match: Match) => new Date(match.startTime).getTime();

export const getMatchById = (id: string) => matches.find((item) => item.id === id);

export const getMatchesByLeague = (league: LeagueKey) => matches.filter((item) => item.league === league);

export const sortByTime = (list: Match[], direction: 'asc' | 'desc' = 'desc') =>
  [...list].sort((a, b) => (direction === 'asc' ? matchTime(a) - matchTime(b) : matchTime(b) - matchTime(a)));

export const liveAndUpcoming = (list: Match[]) =>
  sortByTime(list.filter((item) => item.status === 'live'), 'asc').concat(
    sortByTime(list.filter((item) => item.status === 'upcoming'), 'asc'),
  );

export const relatedMatches = (match: Match, limit = 3) =>
  sortByTime(
    matches.filter((item) => item.id !== match.id && (item.league === match.league || item.status === 'upcoming')),
  ).slice(0, limit);

export const searchMatches = (keyword: string) => {
  const key = keyword.trim().toLowerCase();
  if (!key) return [];
  return sortByTime(
    matches.filter((item) => {
      const haystack = [
        item.home.name,
        item.away.name,
        item.home.shortName,
        item.away.shortName,
        item.leagueLabel,
        leagueMeta[item.league].name,
        item.round,
        `${item.home.name}VS${item.away.name}`,
        `${item.home.name}vs${item.away.name}`,
      ]
        .join(' ')
        .toLowerCase();
      return haystack.includes(key);
    }),
  );
};

export const isToday = (iso: string) => {
  const target = new Date(iso);
  const now = new Date();
  return (
    target.getFullYear() === now.getFullYear() &&
    target.getMonth() === now.getMonth() &&
    target.getDate() === now.getDate()
  );
};

export const isThisWeek = (iso: string) => {
  const target = new Date(iso).getTime();
  const now = new Date().getTime();
  const sevenDays = 7 * 24 * 60 * 60 * 1000;
  return target - now <= sevenDays && target - now >= -sevenDays;
};

export const setPageMeta = (title: string, description: string, keywords?: string) => {
  if (typeof document === 'undefined') return;
  document.title = title;
  const ensure = (name: string) => {
    let el = document.head.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
    if (!el) {
      el = document.createElement('meta');
      el.setAttribute('name', name);
      document.head.appendChild(el);
    }
    return el;
  };
  ensure('description').setAttribute('content', description);
  if (keywords) ensure('keywords').setAttribute('content', keywords);
};